var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"app-invoice-preview"},[_c('v-col',{attrs:{"cols":"12","md":"12"}},[_c('invoice-editable',{attrs:{"data":_vm.locaux}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }